import type { ThemeOptions } from '@mui/material/styles';

const stack = [
  '"Inter Variable"',
  'Inter',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  'Helvetica',
  'Arial',
  'sans-serif',
].join(',');

export const typography: ThemeOptions['typography'] = {
  fontFamily: stack,
  h1: { fontSize: 'clamp(2.25rem, 5vw, 3.75rem)', fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1.05 },
  h2: { fontSize: 'clamp(1.75rem, 3.5vw, 2.5rem)', fontWeight: 700, letterSpacing: '-0.02em', lineHeight: 1.15 },
  h3: { fontSize: 'clamp(1.375rem, 2.5vw, 1.75rem)', fontWeight: 700, letterSpacing: '-0.015em' },
  h4: { fontSize: '1.25rem', fontWeight: 700, letterSpacing: '-0.01em' },
  h5: { fontSize: '1.0625rem', fontWeight: 650 },
  h6: { fontSize: '0.9375rem', fontWeight: 650 },
  subtitle1: { fontSize: '1.0625rem', lineHeight: 1.6 },
  subtitle2: { fontSize: '0.875rem', fontWeight: 600, letterSpacing: '0.02em' },
  body1: { fontSize: '1rem', lineHeight: 1.65 },
  body2: { fontSize: '0.875rem', lineHeight: 1.6 },
  button: { fontWeight: 600, letterSpacing: '0.01em', textTransform: 'none' },
  overline: { fontSize: '0.6875rem', fontWeight: 700, letterSpacing: '0.16em', textTransform: 'uppercase' },
  caption: { fontSize: '0.75rem', lineHeight: 1.5 },
};
